import React , { Component } from 'react';
import Help from './Help';
import LanguageSwitcher from './LanguageSwitcher';


class HeaderToolbar extends Component {

    render() {
        return (
            <div className="navbar-collapse navbar-collapse-pf-site collapse">

                    <LanguageSwitcher {...this.props} />
                  <Help/>;
            </div>
        )
    }
}

export default HeaderToolbar;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderToolbar.js